/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
// eslint-disable-next-line jira/wrm/no-load-bridge
import { loadBridge, waitForHeritage } from '@jira/platform__bridge/src';
import { waitForJQuery } from './common/index.tsx';
import type { ACJSHost } from './types.tsx';

// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports, jira/export/restrict-types-re-export
export type { ACJSHost };
const installConnectJs = async () => {
	// we need the heritage to load in order for WRM core and jQuery to exist.
	// eslint-disable-next-line jira/wrm/no-load-bridge
	await waitForHeritage();
	await waitForJQuery();

	const loader = await import(/* webpackChunkName: "async-connect-js-api" */ './loader.tsx');
	await loader.performSideEffects();

	// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
	return window.connectHost;
};

let installConnectJsPromise: Promise<ACJSHost> | null = null;

export const setupConnectJs = async (): Promise<ACJSHost> => {
	// Connect should never be loaded on SSR
	if (__SERVER__) {
		throw new Error('setupConnectJs should never be called in SSR');
	}

	// Only pages in the SPA will benefit from modernising connect
	if (installConnectJsPromise != null) {
		return installConnectJsPromise;
	}

	// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
	if (window.__SPA__) {
		if (installConnectJsPromise === null) {
			installConnectJsPromise = installConnectJs();
		}

		return installConnectJsPromise;
	}
	// eslint-disable-next-line jira/wrm/no-load-bridge
	installConnectJsPromise = loadBridge({
		name: 'ac/create',
		wrmKeys: [
			'wrc!com.atlassian.plugins.atlassian-connect-plugin:jira-atlassian-connect-resources-v5',
			// Undeclared Dependency: jira/navigation
			'wrc!com.atlassian.jira.jira-atlaskit-plugin:sidebar',
		],
	});
	await installConnectJsPromise;

	// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
	return window.connectHost;
};
